
import React, {useState ,useEffect} from 'react';
import {Link} from "react-router-dom";

import useGoogleCharts from '../../components/useGoogleCharts.js';
import {_getCoutryGoogleChartName} from '../../helpers/helpers.js'
import CountriesLeadList from '../../components/countriesLeadList.js'
import TLDLeadList from '../../components/tldLeadList.js'
import GeoDistribution from '../../components/geoDistribution.js'
import DomainTable from '../../components/domainTable.js'
import CountryFlagAndName from '../../components/countryFlagAndName.js'
import DistributionByPopularityChart from '../../components/technologyDistributionChart.js'
import TechnologySmallIcon from '../../components/technologySmallIcon.js'
import VersionDistributionChart from '../../components/versionDistributionChart.js'
import CopyLink from '../../components/copyLink.js'
import FAQ from '../../components/faqComponent.js'
import { DataSetCVEData} from '../../components/structuredData.js'

import {
	_printDate, 
	_printMediumDate,
	_printNumber, 
	_printPercent, 
	_extractWebsiteFromURL,
	_isGoogleIcon,
	_getGoogleIcon,
    _countryNameFromCode
	} from '../../helpers/helpers'


import {CreditInfo, CVEVulnVersionRange, RtCVEPageResult, RtCVEStatsFullResult} from '../../../../server/routes/cve.js'

interface ComponentProps {
    props: PageResultEx;
    google?: wts_approved_any;
}

interface PageResultEx extends RtCVEStatsFullResult {
	TotalDomainCount: number
} 

interface VersionListProps {
    versions: CVEVulnVersionRange[];
}

interface CreditsProps {
    credits: CreditInfo;
}


function _printRealPercent(percent: number | undefined): string | undefined {
	if (undefined == percent) return percent;
	if (percent >= 100) return '100';
	if (percent < 0.1) return 'less than 0.1';
	if (percent >= 10) return percent.toFixed(0);
	return percent.toFixed(2);
}

function TrimCWEPrefix(descr: string): string {
    // remove CWE-
    return descr.substring(4)
}

interface CVEProps {
    server: string;
    pageData: unknown;
}

export default function CVE({server, pageData}: CVEProps) {

	const typedPageData = pageData as RtCVEStatsFullResult;
	const initDataValue: PageResultEx = {
		...typedPageData, 
		TotalDomainCount: 0
	}
	let [data, setData] = useState(initDataValue);
	const google = useGoogleCharts();

	data.TotalDomainCount = 0;
	if (data.TechnologyVersions) {
		data.TechnologyVersions.map ( (version ) =>{
			data.TotalDomainCount += version.DomainCount;
		});	
	}

	if (data.CVEInfo == null){
		return (
			<>		
				<section className="section section-sm">
					<div className="container">
						<div className="row row-50">
							<div className="col-md-8 col-lg-8 col-xl-8">
								Unknown CVE number
							</div>				
						</div>
					</div>
				</section>
			</>
		)		
	}
	else 
	{
		return (
			<>
				<DataSetCVEData cve={data.CVE} url={data.CVE} />
				<section className="section section-sm">
					<div className="container">
						<div className="row row-50">
							<div className="col-md-8 col-lg-8 col-xl-8">
								<CVELeftPanel props={data} google={google} />
							</div>
							<div className="col-md-4 col-lg-4 col-xl-4">
								<CVERightPanel props={data} />
							</div>					
						</div>
						<CVEBottomPanel props={data} google={google} />				
					</div>
				</section>
			</>
		)
	};		
}

function CVEBottomPanel({props, google}: ComponentProps) { 
	return (
		<>			
			<AffectedVersions props={props} google={google}/>
			{/* <GeoDistribution link={props.CanonicalURL} geoData={props.GeoData} google={google} 
				totalCount={props.TotalDomainCount}/> */}
			<GeoDistribution link={props.CanonicalURL} geoData={props.GeoData} google={google} />
			<CVEWebsites props={props}/>
			<FAQ faqs={props.faqs} expanded='1'/>	
			<CVEInfoReferences props={props} />
		</>
	)
}

function CVELeftPanel({props, google}: ComponentProps) {
	return (
		<>
			<h3 style={{wordWrap: 'break-word'}}>{props.PageTitle}</h3>
            {/*Common Vulnerabilities and Exposures number - {props.CVE} */}
			<b>{props.CVEInfo.Title}</b>
			<p>
			{props.CVEInfo.Description}
			</p>
			<hr/>
			{
				props.DomainCount == 0 &&
				<NotInDatabase props={props}/>
			}
			{
				props.DomainCount != 0 &&
					<HasDomainCVE props={props}/>
			}		
			<hr/>			
			<AffectedSoftware props={props}/>
			{
				!!props.CWEInfo &&
				<>
					<div>
						<h3>Common Weakness Enumeration</h3>
						<Link
							className="link-hover" 
							rel="noopener nofollow" 
							title={`${props.CWEInfo.Title}`}
							to={`/cwe/${props.CWEInfo.CWEId}`}
						>
							<b>{props.CWEInfo.CWEId}</b>
						</Link>	
						{' '}{props.CWEInfo.Title}				
					</div>			
					<br />
					<br />
				</>
			}	
			<DistributionByPopularityChart 
				subtitle={`The diagram provides a graphic representation of the correlation between the occurrence of ${props.CVE} and the relative popularity of websites`}
				distribution={props.DistributionByPopularity} 
				google={google} link={props.CanonicalURL} />
		</>
	)
}


function CVERightPanel({props}: {props: RtCVEStatsFullResult}) {
	return (
		<div className="row row-35 row-lg-50">
			<div className="col-sm-12 col-lg-12">
				<CVEAvailableReports props={props}/>
				<CVEDetails props={props}/>	
				<CVECredits props={props}/>	
				<CVEExternalLinks props={props}/>				
				<CWEDetails props={props}/>
			    <CountriesLeadList name={props.CVE} reporttype='none'  geoData={props.GeoData} />
				<TLDLeadList name={props.CVE} reporttype='none' tlds={props.TLDs}/>	 
			</div>
		</div>
	)							
}

function NoDomainCVE({props}: {props: RtCVEPageResult}) { 

	return (
		<div className="row row-50">
			<div className="col-12">
                {
				<p>Our analysis found no websites vulnerable to {props.CVE} </p>
                }
			</div>
		</div>
	)
}

function NotInDatabase({props}: {props: RtCVEPageResult}) { 
	if (!props.CanTestCVE) return (<></>);
	if (!props.CVE) return (<></>);

	return (
		<div className="row row-50">
			<div className="col-12">
				<p>The vulnerability was recently discovered, and our website dataset has not been updated to reflect websites affected by it. However, you can still perform a live scan of your website to check for the CVE.</p>
				<p>
					<Link                     
						to={`/cve-security-scan/${props.CVE}`}
						className="button button-secondary" 
						title={`Scan website`} 
						rel="noopener nofollow" 
					>
						Run a Free Instant Scan
					</Link>
				</p>

			</div>
		</div>
	)
}

function HasDomainCVE({props}: {props: RtCVEStatsFullResult}) {

	return (
		<>
			<CVEBrag props={props}/>
		</>
	)
}

function CVEInfoReferences({props}: {props: RtCVEStatsFullResult}) {
	if (!props.CVEInfo.References) return (<></>);
	return (
		<>
			<div>
				<h3>References</h3>
				<ul className="list-marked">
				{
					props.CVEInfo.References.map((reference, indexKey) => {
						return (
							<li key={indexKey}>
								<a
									className="link-hover word-break" 
									rel="noopener nofollow" 
									target="_blank" 
									href={reference} 
								>
									{reference} &nbsp;&nbsp;&nbsp;
									<span style={{color:'black'}} className="icon text-right fa fa-external_link"/>
								</a>				
							</li>
							)
						})
				}
				</ul>
			</div>			
		</>
	)
}

function CVEBrag({props}: {props: RtCVEStatsFullResult}) {
    let CVE = props.CVE;
    let title = props.Domains.Header!.Subtitle;

	return (
		<>
			<p>
				We have discovered&nbsp;
				<Link 
					to={props.Domains.Button!.Href}
					className="link-hover" 
					title={props.Domains.Header!.Title} 
					rel="noopener nofollow" 
				> 
				<b>{_printNumber(props.DomainCount)} live websites</b>
				</Link>&nbsp;that are affected by {CVE}.
			</p>
			<p>
				<Link                     
					to={`/cve-security-scan/${CVE}`}
					className="button button-secondary" 
					title={`Scan website`} 
					rel="noopener nofollow" 
				>
					Run a Free Instant Scan
				</Link>
			</p>
			{
				/*
			<p>
				<Link 
					to={`/create-report?cve=${CVE}`}
					className="button button-secondary" 
					title={`Download list of websites that are using tag ID ${CVE}`} 
					rel="noopener nofollow" 
				>
					Download Lead List
				</Link>
			</p>				 
			*/
			}

			<br />
			<br />
		</>
	)
}


function CVEUsageStats({props}: {props: RtCVEStatsFullResult}) {
	// Disabled because ont that interesting

	return (
		<>
			<div className="row row-50">
			<div className="col-12">
				<h3 className="text-left">{props.CVE} statistics</h3>
				<table className="table-custom table-custom-striped table-custom-primary">
					<tbody>
						<tr>
							<td>Websites vulnerable to {props.CVE}</td>
							<td>
								<span className="icon text-primary">
									<Link 
										to={props.Domains!.Button!.Href}
										className="link-hover" 
										title={props.Domains.Header!.Subtitle} 
									>
										<b>{_printNumber(props.DomainCount)}</b> websites
									</Link>
								</span>
							</td>
						</tr>
						{
							// props.Usage != undefined && props.Usage.LastMonthChange &&
							// 	<tr>
							// 		<td>Change from last month</td>
							// 		<td>
							// 			<span 
							// 				className="icon  mdi mdi-arrow-down" 
							// 				style={{color: 'red'}}
							// 			>
							// 				<b>
							// 					{props.Usage.LastMonthChange}%
							// 				</b>
							// 			</span>
							// 		</td>
							// 	</tr>
						}
						{
							props.Usage != undefined && props.Usage.MostPopularCountry &&
    							<tr>
                                    <td>
                                        Most prevalent in the country
                                    </td>
                                    <td>
                                        <b>
                                            <CountryFlagAndName countryCode={props.Usage.MostPopularCountry.Country} />
                                        </b>
                                    </td>
                                </tr>  
                        }
                        {    
							props.Usage != undefined && props.GeoData.Countries && props.Usage.DomainCount &&
                            <tr>
                                <td>
                                	Websites affected by {props.CVE} hosted in {_countryNameFromCode(props.Usage.MostPopularCountry.Country)}
                                </td>
                                <td>
                                    <b>
                                        {_printPercent(props.GeoData.Countries[0].DomainCount/props.Usage.DomainCount)}%
                                    </b>
                                </td>
                            </tr>
						}
					</tbody>
				</table>
			</div>
		</div>
	</>
	)
}

function CVEWebsites({props}: {props: RtCVEStatsFullResult}) {
	if (!props.DomainCount) return (<></>);  
	return (
		<DomainTable domainList={props.Domains}/>
	)
}

function CVEAvailableReports({props}: {props: RtCVEStatsFullResult}) {
    if (!props || !props.DomainCount) return null;

	return (
		<>
			<article className="box-bordered">
				<h4>Available Reports</h4>
				<div>
					<ul>
						<li>
							<Link 
								to={props.Domains.Button!.Href}
								className="link-hover" 
								title={props.Domains.Header!.Subtitle}
							>
								Website List
							</Link>
						</li>       
						{
							// props.Developments &&                                       
							// <li>
							// 	<Link 
							// 		to={`/cve/${props.CVE}/changes`} 
							// 		className="link-hover" 
							// 		title={`${props.CVE} adoption report`}
							// 	>
							// 		Usage Changes
							// 	</Link>
							// </li>
						}                                        
					</ul>      
				</div>
			</article>
			<br />
		</>
	)
}

function CVEDetails({props}: {props: RtCVEStatsFullResult}) {
	return (
		<>
			<article className="box-bordered">
				<h4>Details</h4>
				<ul className="list-marked">
			{/** noone cares		<li>Reserved - {_printMediumDate(props.CVEInfo.DateReserved)}</li>							 */}
					<li>Published - {_printMediumDate(props.CVEInfo.DatePublished)}</li>						
					{
						!!props.CVEInfo.DateUpdated &&
					<li>Updated - {_printMediumDate(props.CVEInfo.DateUpdated)}</li>							
					}	
				</ul>
			</article>		
		</>
	)
}

function CVECredits({props}: {props: RtCVEStatsFullResult}) {
	if (!props.CVEInfo.Credits) return (<></>);
	if (props.CVEInfo.Credits.length == 0) return (<></>);
	
	return (
		<>
			<article className="box-bordered">
				<h4>Credits</h4>
				<ul className="list-marked">	
					{
						props.CVEInfo.Credits.map((c, indexKey) => {
							return (
								<Credits credits={c} key={indexKey}/>
								)
						})
					}										
				</ul>
			</article>		
		</>
	)
}

function Credits({credits}: CreditsProps) {
	if (!credits) return (<></>);
	if (credits.type != undefined) {
		return (<li>{credits.value} (<i>{credits.type}</i>)</li>);
	} else {
		return (<li>{credits.value}</li>);
	}
}

function CWEDetails({props}: {props: RtCVEStatsFullResult}) {
	if (!props.CWEInfo && !props.CVEInfo.CWEId) 
		return (<></>);
	if (props.CVEInfo.CWEId == 'CWE-null') return (<></>);

	if (!props.CWEInfo) return (
		<>
			<article className="box-bordered">
				<h4>CWE</h4>
				<ul className="list-marked">
					<li><b>{props.CVEInfo.CWEId}</b></li>				
				</ul>
			</article>
		</>	
	);

	return (
		<>
			<article className="box-bordered">
				<h4>CWE</h4>
				<ul className="list-marked">
					<li>
						<Link
							className="link-hover" 
							rel="noopener nofollow" 
							title={`${props.CWEInfo.Title}`}
							to={`/cwe/${props.CWEInfo.CWEId}`}
						>
							<b>{props.CWEInfo.CWEId}</b>
						</Link>
					</li>				
				</ul>
			</article>
	
		</>
	)
}


function CVEExternalLinks({props}: {props: RtCVEStatsFullResult}) {

	// https://github.com/CVEProject/cvelistV5/blob/main/cves/2025/45xxx/CVE-2025-45007.json
	let github: string | null = null;
	let parts = props.CVE.split('-');
	if (parts.length == 3){
		let year = parts[1];
		let num = parts[2];
		let xxx = (num.length <= 3) ? '0' : num.slice(0, -3);
		github = `https://github.com/CVEProject/cvelistV5/blob/main/cves/${year}/${xxx}xxx/${props.CVE}.json`;
	}

	return (
		<>
			<article className="box-bordered">
				<h4>CVE References</h4>
				<ul className="list-marked">				
					<li>
						<b>
						<a
							className="link-hover" 
							rel="noopener nofollow" 
							target="_blank" 
							title={`${props.CVE}`}
							href={`https://www.cve.org/CVERecord?id=${props.CVE}`} 
						>
							www.cve.org &nbsp;&nbsp;&nbsp;
							<span style={{color:'black'}} className="icon text-right fa fa-external_link"/>
						</a>
						</b>
					</li>						
					<li>
						<b>
						<a
							className="link-hover" 
							rel="noopener nofollow" 
							target="_blank" 
							title={`${props.CVE}`}
							href={`https://cve.mitre.org/cgi-bin/cvename.cgi?name=${props.CVE}`} 
						>
							cve.mitre.org &nbsp;&nbsp;&nbsp;
							<span style={{color:'black'}} className="icon text-right fa fa-external_link"/>
						</a>
						</b>
					</li>					
					<li>
						<b>
						<a
							className="link-hover" 
							rel="noopener nofollow" 
							target="_blank" 
							title={`${props.CVE}`}
							href={`https://nvd.nist.gov/vuln/detail/${props.CVE}`}
						>
							nvd.nist.gov &nbsp;&nbsp;&nbsp;
							<span style={{color:'black'}} className="icon text-right fa fa-external_link"/>
						</a>
						</b>
					</li>
					{
						github &&
						<li>
							<b>
							<a
								className="link-hover" 
								rel="noopener nofollow" 
								target="_blank" 
								title={`${props.CVE}`}
								href={`${github}`}
							>
								Github Repository &nbsp;&nbsp;&nbsp;
								<span style={{color:'black'}} className="icon text-right fa fa-external_link"/>
							</a>
							</b>
						</li>					
					}
				</ul>
			</article>				
			<CWEReference props = {props}/>
		</>
	)
}

function CWEReference({props}: {props: RtCVEStatsFullResult})
{
	if (!props.CWEInfo) return (<></>);
	if (!props.CVEInfo.CWEId) return (<></>);
	if (props.CVEInfo.CWEId == 'CWE-null') return (<></>);
	let description = '';
	let CWEId = props.CVEInfo.CWEId;
	if (props.CWEInfo) {
		CWEId = props.CWEInfo.CWEId;
		description = props.CWEInfo.Title;
	}

	return (
		<article className="box-bordered">
			<h4>CWE References</h4>
			<ul className="list-marked">				
				<li>
					<b>
					<a
						className="link-hover" 
						rel="noopener nofollow" 
						target="_blank" 
						title={`${description}`}				
						href={`https://cwe.mitre.org/data/definitions/${TrimCWEPrefix(CWEId)}`}
					>
						cwe.mitre.org &nbsp;&nbsp;&nbsp;
						<span style={{color:'black'}} className="icon text-right fa fa-external_link"/>
					</a>
					</b>
				</li>
			</ul>
		</article>					
	)
}

// function AffectedSoftware3({props}: {props: RtCVEStatsFullResult}) {
// 	if (!props.CVEInfo.CVETechnologyInfo) return  (<></>);
	
// 	let techInfo = props.CVEInfo.CVETechnologyInfo
// 	return (
// 		<>
// 			<hr/>
// 			<div>
// 			<h3>Vulnerable Product</h3>
// 			<b>
// 			<Link 
// 					to={`/technology/${techInfo.URL}`}
// 					className="link-hover" 
// 					title={techInfo.ShortName} 
// 					rel="noopener nofollow" 
// 			> {techInfo.ShortName}</Link>
// 			</b>&nbsp;
// 			version up to {techInfo.VersionTo}
// 								{
// 									techInfo.VersionToInclusive == true && 
// 									<> (including) </>
// 								}
// 			from Category <b>
// 								<Link 
// 									to={`/technology/${techInfo.CategoryURL}`}
// 									className="link-hover" 
// 									title={techInfo.Category} 
// 									rel="noopener nofollow" 
// 							> {techInfo.Category}</Link>
// 							</b>
// 			</div>		
// 		</>
// 	)
// }

function AffectedSoftware({props}: {props: PageResultEx}) {
	if (!props.CVEInfo) return  (<></>);
	if (!props.CVEInfo.CVETechnologyInfo) return  (<></>);
	let techInfo = props.CVEInfo.CVETechnologyInfo;
	let vulnVersions: number = 0;
	let vulnPercentage: number = 0;
	props.TechnologyVersions.forEach( v => {
		if (v.Vulnerable) vulnVersions++;
	})
	vulnPercentage = props.TechnologyVersions.length ? (100*vulnVersions / props.TechnologyVersions.length) : 0;
	
	return (
		<>			
			<div className="row row-50">
			<div className="col-12">
				<h3 className="text-left" id='technology'>Affected Software
				<CopyLink link={props.CanonicalURL}  anchor='technology'/>  
				</h3>
				<table className="table-custom table-custom-striped table-custom-primary">
					<thead>
						<tr>
							<th style={{width: '30%'}}></th>
							<th style={{width: '70%'}}></th> 				
						</tr>
					</thead>
					<tbody>
						<tr>
							<td>Product</td>
							<td>
								<TechnologySmallIcon 
									technologyIcon={techInfo.Icon} 
									technology={techInfo.ShortName}
								/>&nbsp;
								<span className="icon text-primary">
									<b>									
									<Link 
										to={`/technology/${techInfo.URL}`}
										className="link-hover" 
										title={techInfo.ShortName} 
									> {techInfo.ShortName}
									</Link>
									</b>
								</span>
							</td>
						</tr>
						<tr>
							<td>
								Category
							</td>
							<td>
								<b>
								<Link 
									to={`/technology-type/${techInfo.CategoryURL}`}
									className="link-hover" 
									title={techInfo.Category} 
									rel="noopener nofollow" 
							> {techInfo.Category}</Link>
								</b>
							</td>
						</tr>  
						<tr>
							<td>
								Vulnerable Domains
							</td>
							<td>
								<Link 
										to={props.Domains.Button!.Href}
										className="link-hover" 
									>
									<b>{_printNumber(props.DomainCount)}</b>
								</Link> live websites 
								(<b>{_printRealPercent(100*props.DomainCount/props.TotalDomainCount)}%</b> of {techInfo.ShortName} install base)
							</td>
						</tr> 						
						{
							!!props.CVEVersions && 
							<>
							<tr>
								<td>Vulnerable Versions</td>
								<td>
									<VersionList versions={props.CVEVersions || []} />
								</td>
							</tr>						
							<tr>
							<td>
								Vulnerable Versions Count
							</td>
							<td>
								<Link 
										to={`/technology/${techInfo.URL}/versions`}
										className="link-hover" 
										title={techInfo.ShortName} 
									> 
									<b>{_printNumber(vulnVersions)}</b>					
								</Link>{' '}
								versions ( <b>{_printRealPercent(vulnPercentage)}%</b> of all versions)
							</td>						
							</tr> 	
							</>					
						}																				
					</tbody>
				</table>
			</div>
		</div>		
		{/** dont need it after the table	<hr/>		 */}	
		<br />
		<br />
	</>
	)
}

function VersionList({versions}: VersionListProps) {

	if (!versions) return (<></>);
	if (!versions.length) return (<></>);

	let ver = versions;
	
	return (
		<ul>
		{
		ver.map((version, indexKey) => {
				if (version.VersionTo == undefined) {
					return (<li key={indexKey}>
						from  {version.VersionFrom} 		
					</li>);
				} else if (version.VersionToInclusive === false) {
					return (<li key={indexKey}>
						from <b>{version.VersionFrom}</b> before <b>{version.VersionTo}</b>		
					</li>);
				} else {
					return (<li key={indexKey}>
						from <b>{version.VersionFrom}</b> through <b>{version.VersionTo}</b>		
					</li>);
				}
			 })
		}
		</ul>
	);
}

function AffectedVersions({props, google}: ComponentProps) {
	if (!props.TechnologyVersions) return  (<></>);
	if (!props.TechnologyVersions.length) return  (<></>);
	let versions = props.TechnologyVersions;

	return (
		<>			
		<div className="row row-50">
		<div className="col-12">
			<h3 className="text-left" id='versions'>Vulnerable Versions
			<CopyLink link={props.CanonicalURL}  anchor='versions'/>  
			</h3>
			Vulnerable versions are highlighted in red
			<VersionDistributionChart versions={versions} google={google}/>		
		</div>
		</div>		
		</>
	)
}